import React, { useEffect } from "react";
import { Modal } from '@appkit4/react-components/modal';
import { Button } from '@appkit4/react-components/button';
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import { loginRequest, msalInstance } from "../../auth/msalConfig";

const SessionTimeout: React.FC = () => {

  const [visible, setVisible] = React.useState(false);
  const showSessionTimeout = useSelector((state: RootState) => state.auth.showSessionTimeout)
  useEffect(() => {
    setVisible(showSessionTimeout)
  }, [showSessionTimeout])

  const loginRedirect = async () => {
    await msalInstance.loginRedirect(loginRequest)
  }
  return (<>
    <Modal
      visible={visible}
      title={"Session Timed Out"}
      ariaLabel={"Session Timed Out"}
      closable={false}
      maskCloseable={false}
      modalStyle={{ width: '33.75rem' }}
      footerStyle={{ 'paddingTop': '8px', 'marginTop': '-8px', 'minHeight': '64px' }}
      header={""}
      icons={""}
      footer={
        <>
          <Button onClick={async () => await loginRedirect()}>Login</Button>
        </>
      }
      bodyStyle={{ minHeight: '92px' }}
    >
      <p>Your session has timed out. Please log in again. Note that you might need to reupload files to fetch their results. </p>
    </Modal>
  </>);
}

export default SessionTimeout